import { CircleAlert } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

const SignatoryTooltip = ({ isSignatoryMissing }: { isSignatoryMissing: boolean }) => {
  if (!isSignatoryMissing) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <CircleAlert className="size-4 text-orange-700" />
        </TooltipTrigger>
        <TooltipContent side="top" align="center" className="max-w-[250px]">
          Assign at least one (1) representative below who will be responsible for signing the agreement.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SignatoryTooltip;
